// Rendu du curseur produit par useOverlayScrollbarThumb.
// Composant purement présentationnel : aucune logique de scroll ici.
const OverlayScrollbarThumb = ({ thumb, visible }) => {
  if (!thumb) return null

  return (
    <div
      className='overlay-scrollbar-thumb'
      style={{
        position: 'absolute',
        top: thumb.top,
        right: thumb.right + 3,
        width: 6,
        height: thumb.height,
        borderRadius: 3,
        backgroundColor: 'rgba(11, 34, 57, 0.35)',
        opacity: visible ? 1 : 0,
        // Apparition rapide, disparition plus lente et progressive (comme VS Code).
        transition: visible ? 'opacity 0.1s ease' : 'opacity 0.9s ease',
        pointerEvents: 'none',
      }}
    />
  )
}

export default OverlayScrollbarThumb
